import styled from 'styled-components';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './style.css';
import { Auth } from 'aws-amplify';
import { getPageGroupFromPath, trackInternalNavigationIfConsented } from './pageAnalytics';

const Ul = styled.ul`
  list-style: none;
  flex-flow: row nowrap;
  display: flex;
  margin: 0;
  padding: 0;
  li {
    padding: 8px 10px;
  }
  @media (max-width: 485px) {
    flex-flow: column nowrap;
    background-color: #0D2538;
    position: fixed;
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    li {
      color: #fff;
    }
  }
`;

const RightNav = ({ open, setOpen, logged, userName }) => {
  const location = useLocation();
  const currentPageGroup = getPageGroupFromPath(location.pathname);
  const closeMenu = () => setOpen(false);

  const handleNavClick = (linkTarget, destinationPageGroup, linkContext) => {
    trackInternalNavigationIfConsented({
      link_target: linkTarget,
      link_context: linkContext,
      source_page_group: currentPageGroup,
      destination_page_group: destinationPageGroup,
    });
    closeMenu();
  };

  const signOut = async () => {
    try {
      await Auth.signOut();
      window.location.assign('/');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Ul className="nav-links" open={open}>
        <li className="nav-link">
          <NavLink to="/" className="nav-link" onClick={() => handleNavClick('/', 'home', 'nav_home')}>
            Home
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink
            to="/desk-setup-ideas"
            className="nav-link"
            onClick={() => handleNavClick('/desk-setup-ideas', 'search_hub', 'nav_setup_ideas')}
          >
            Setup ideas
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink to="/latest" className="nav-link" onClick={() => handleNavClick('/latest', 'latest_page', 'nav_latest')}>
            Latest
          </NavLink>
        </li>
        <li className="nav-link">
          <NavLink
            to="/ImgDropAndCrop"
            className="nav-link"
            onClick={() => handleNavClick('/ImgDropAndCrop', 'upload_page', 'nav_upload')}
          >
            Upload
          </NavLink>
        </li>
        {logged ? (
          <li className="nav-link-user">
            {userName}{' '}
            <button type="button" onClick={signOut}>
              Log out
            </button>
          </li>
        ) : (
          <li className="nav-link">
            <NavLink onClick={() => handleNavClick('/login', 'auth_page', 'nav_login')} to="/login" className="nav-link">
              Login
            </NavLink>
          </li>
        )}
      </Ul>
    </div>
  );
};

export default RightNav;
